import { graphql } from 'gatsby';
import React from 'react';
import { ScheduleCalendar } from '../components/schedule-calendar';
import { useLocalize } from '../components/localize-context';
import { Seo } from '../components/seo';
import { ScheduleChecker } from '../components/schedule-checker';

export default function Schedule({ data: { schedule } }) {
  const localize = useLocalize();

  return (
    <>
      <Seo title={localize('Sky Mirror Departure Time')} />
      <div className="container mx-auto max-w-3xl py-6 px-4">
        <h1 className="text-3xl md:text-5xl text-center mb-4">
          {localize('Sky Mirror Departure Time')}
        </h1>
        <div className="max-w-sm mx-auto block md:hidden">
          <ScheduleChecker schedules={schedule.checkerNodes} />
        </div>
        <div className="max-w-3xl mx-auto hidden md:block">
          <ScheduleCalendar schedules={schedule.nodes} />
        </div>
      </div>
    </>
  );
}

export const pageQuery = graphql`
  query ScheduleQuery {
    schedule: allScheduleYaml(sort: { fields: date }) {
      nodes {
        ...ScheduleCalendar
      }
      checkerNodes: nodes {
        ...ScheduleChecker
      }
    }
  }
`;
